import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updateGeneratedBriefDescription } from '../api'
import { contentKeys } from '../queryKeys'

const useUpdateGeneratedBriefDescriptionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateGeneratedBriefDescription,
    onSuccess: (content) => {
      queryClient.setQueryData(contentKeys.content(content._id), content)
    },
  })
}

export default useUpdateGeneratedBriefDescriptionMutation
